import { environment as devEnvironment } from './environment.dev';
import { environment as stgEnvironment } from './environment.stg';
import { environment as rhsEnvironment } from './environment.rhs';
import { environment as prodEnvironment } from './environment.prod';
import { environment as localEnvironment } from './environment.local';

export interface Environment {
    apiUrl: string;
    urlDevicePrint: string;
    formatArchiveUrl: string;
    urlFormatContainer: string;
    urlFormatUser: string;
    formatIdNumber: number;
}

let environment: Environment;
// CRA only inlines REACT_APP_* vars into the client bundle. deploy.sh sets
// REACT_APP_FLAVOR per environment (develop|staging|rehearsal|production).
const flavor = process.env.REACT_APP_FLAVOR ?? 'production';

switch (flavor) {
    case 'local':
        environment = localEnvironment;
        break;
    case 'develop':
        environment = devEnvironment;
        break;
    case 'staging':
        environment = stgEnvironment;
        break;
    case 'rehearsal':
        environment = rhsEnvironment;
        break;
    case 'production':
    default:
        environment = prodEnvironment;
        break;
}

export { environment };
